import EleMultiCascader from './multiCascader.vue';

/* istanbul ignore next */
EleMultiCascader.install = function(Vue) {
  Vue.component(EleMultiCascader.name, EleMultiCascader);
};

export default EleMultiCascader;



// WEBPACK FOOTER //
// ./src/components/customComponents/multiCascader/index.js